import { gql } from '@apollo/client';

const triggerExperimentImpression = gql`
  query TriggerExperimentImpressionQuery(
    $sellerInputUUID: String!
    $experimentInputs: [ExperimentVariationInput!]!
    $attributes: JSONObject
  ) {
    reception {
      getSellerInput(input: { uuid: $sellerInputUUID }) {
        sellerInput {
          experimentVariations(inputs: $experimentInputs, attributes: $attributes) {
            name
            variation
          }
        }
      }
    }
  }
`;

export default triggerExperimentImpression;
